import { call, take } from 'redux-saga/effects';
import axios          from 'axios';

const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/registerEmail.php';

function* getTotalLikes(): Generator<any,any,any> {
  while(true) {
    try {

        const input = yield take('REGISTER_EMAIL_SAGA');

        if (process.env.NODE_ENV === 'development') {
          console.log('input.payload  :   ',input.payload)
        }
        if (process.env.NODE_ENV === 'production') {

            const res = yield call( axios.post, endpoint, input.payload);        
            console.log('res : ',res)
        }
        
    }
    catch(err) {
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default getTotalLikes;











